import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import type { HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApplicationInsightsService } from '@services/application-insights.service';
import { AuthService } from '@services/auth.service';
import { environment } from '@environments/environment';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService, private readonly applicationInsightsService: ApplicationInsightsService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip auth completely in MSW/mock mode
    if (environment.skipAuth) {
      return next.handle(request);
    }

    return this.addJwtToken(request).pipe(
      switchMap((expandedRequest) => {
        return next.handle(expandedRequest);
      }),
    );
  }

  addJwtToken<T>(request: HttpRequest<T>): Observable<HttpRequest<T>> {
    return this.authService.getAccessToken().pipe(
      map((token) => {
        if (token == null) {
          const userEmail = this.authService.getUserEmail();
          const requestUrl = request.url;
          this.applicationInsightsService.trackEvent('No token found for addJwtToken', { userEmail, requestUrl });
        }
        return token != null
          ? request.clone({
            headers: request.headers.set('Authorization', `Bearer ${token}`),
          })
          : request;
      }),
    );
  }
}
